export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5266.6911f9e6.jpg";